import ReportTable from "../../../components/Reports/RequestPerHourReport"

const ReportPage = () => {
    return <ReportTable/>
}

export default ReportPage;